import { twMerge } from "tailwind-merge";

type ButtonGroupProps = {
  className?: string;
  children: React.ReactNode;
};

const ButtonGroup = ({ className, children }: ButtonGroupProps) => {
  return (
    <div className={twMerge("inline-flex items-center gap-2", className)}>
      {children}
    </div>
  );
};

export { ButtonGroup };
